import { CmtsCapaPanel } from "../components/capa/CmtsCapaPanel.js";
export type CmtsCapaPageProps = Readonly<{ selectedRecordId?: string | undefined; diagnostics?: unknown | undefined }>;
export function CmtsCapaPage(props: CmtsCapaPageProps) { return <CmtsCapaPanel {...(props.selectedRecordId ? { selectedRecordId: props.selectedRecordId } : {})} />; }
